import type { LegalForm } from "@/types";

export const legalForms: LegalForm[] = [
  {
    code: "SASU",
    label: "SASU",
    family: "société",
    founderCount: "solo",
    summary: "Une société unipersonnelle souple, souvent choisie pour préparer la croissance ou l'entrée future d'associés.",
    bestFor: ["Projet solo structuré", "Développement futur", "Entrée d'investisseurs", "Image de société"],
    watchouts: ["Statuts à rédiger avec attention", "Coût social du président rémunéré", "Comptabilité complète"],
    governance: "Président, avec une grande liberté statutaire.",
    socialRegime: "Président assimilé salarié lorsqu'il est rémunéré.",
    evolution: "Passage naturel vers une SAS si de nouveaux associés entrent.",
    accent: "blue",
  },
  {
    code: "EURL",
    label: "EURL",
    family: "société",
    founderCount: "solo",
    summary: "Une SARL à associé unique, plus encadrée et souvent étudiée pour maîtriser le fonctionnement d'un projet solo.",
    bestFor: ["Projet solo", "Cadre juridique balisé", "Gérant opérationnel", "Vision long terme"],
    watchouts: ["Régime social du gérant à étudier", "Moins de liberté statutaire", "Évolution à organiser"],
    governance: "Gérant associé unique, dans un cadre légal plus structuré.",
    socialRegime: "Gérant associé relevant généralement du régime des indépendants.",
    evolution: "Peut devenir une SARL avec l'arrivée de nouveaux associés.",
    accent: "mint",
  },
  {
    code: "SAS",
    label: "SAS",
    family: "société",
    founderCount: "multiple",
    summary: "Une structure pluripersonnelle flexible, adaptée aux projets qui veulent organiser finement la gouvernance.",
    bestFor: ["Plusieurs associés", "Levée de fonds", "Gouvernance sur mesure", "Croissance rapide"],
    watchouts: ["Statuts plus techniques", "Pacte d'associés à envisager", "Règles de décision à cadrer"],
    governance: "Président obligatoire, organes complémentaires possibles.",
    socialRegime: "Dirigeant assimilé salarié lorsqu'il est rémunéré.",
    evolution: "Très adaptée aux changements de capital et à l'entrée d'investisseurs.",
    accent: "blue",
  },
  {
    code: "SARL",
    label: "SARL",
    family: "société",
    founderCount: "multiple",
    summary: "Une structure pluripersonnelle encadrée, souvent retenue pour des projets stables entre associés identifiés.",
    bestFor: ["Projet à plusieurs", "Cadre connu", "Entreprise familiale", "Répartition claire"],
    watchouts: ["Fonctionnement moins flexible", "Statut social du gérant variable", "Cessions de parts encadrées"],
    governance: "Un ou plusieurs gérants, avec des règles légales structurées.",
    socialRegime: "Dépend de la détention du capital et de la situation du gérant.",
    evolution: "Adaptée à un actionnariat stable et connu.",
    accent: "mint",
  },
  {
    code: "EI",
    label: "Entreprise individuelle",
    family: "entreprise individuelle",
    founderCount: "solo",
    summary: "Une activité exercée en nom propre, sans création d'une personne morale distincte.",
    bestFor: ["Projet solo", "Démarrage simple", "Gestion allégée", "Activité indépendante"],
    watchouts: ["Pas d'associé", "Image différente d'une société", "Options fiscales à examiner"],
    governance: "L'entrepreneur décide seul.",
    socialRegime: "Travailleur indépendant.",
    evolution: "Un passage en société peut être étudié lorsque le projet grandit.",
    accent: "ink",
  },
  {
    code: "MICRO",
    label: "Micro-entreprise",
    family: "entreprise individuelle",
    founderCount: "solo",
    summary: "Un régime simplifié pour tester ou exercer certaines activités dans les limites applicables.",
    bestFor: ["Test d'activité", "Faibles charges initiales", "Gestion simple", "Activité complémentaire"],
    watchouts: ["Seuils et règles du régime", "Déduction des charges limitée", "Pas d'associé"],
    governance: "L'entrepreneur décide seul.",
    socialRegime: "Micro-social selon les règles applicables.",
    evolution: "Peut servir de première étape avant une structure plus développée.",
    accent: "blue",
  },
];

export const getLegalForm = (code: string) => legalForms.find((form) => form.code === code);
